import { IDirective } from 'angular'
import { Hotkey, HotkeysService } from './hotkeys.service'

interface HotkeyDirectiveType extends Hotkey {
  tip: string[]
}

export const HotkeyDirective = (hotkeysService: HotkeysService) => {
  'ngInject'

  return {
    restrict: 'A',
    link(scope, $element, attrs) {
      const hotkey: HotkeyDirectiveType = scope.$eval(attrs.hotkey)

      if (!hotkey) {
        return
      }

      const action = hotkey.action ? hotkey.action : performClick

      // Only show a tip if one is supplied
      if (hotkey.tip) {
        // This additional data attribute is used to display a hotkey combo tip
        $element[0].setAttribute(
          'data-hotkey-tip',
          hotkey.tip.toString().toUpperCase()
        )
      }

      function performClick() {
        $element[0].click()
      }

      const { combo, summary, count } = hotkey

      hotkeysService.add({
        action,
        combo,
        summary,
        count,
      })

      scope.$on('$destroy', function () {
        hotkeysService.remove(hotkey.combo)
      })
    },
  } as IDirective
}
